import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { Swiper as SwiperContainer, SwiperSlide } from 'swiper/react';
const variants = {
    blue: 'text-white bg-blue',
    green: 'text-white bg-green',
    gold: 'text-white bg-gold',
    red: 'text-white bg-red',
};
const MobileNavigation = ({ nav }) => {
    const swiper = useRef();
    // Update slide when nav changes
    useEffect(() => {
        const inst = swiper.current;
        if (inst && nav.index !== inst.activeIndex) {
            inst.slideTo(nav.index);
        }
    }, [swiper, nav]);
    return (_jsx("div", { className: "pointer-events-auto", children: _jsx(SwiperContainer, { centeredSlides: true, slidesPerView: "auto", onSwiper: (inst) => (swiper.current = inst), onSlideChange: (inst) => nav.setRoute(inst.activeIndex), children: nav.routes.map((route) => {
                const handleClick = () => nav.setRoute(route);
                return (_jsx(SwiperSlide, { className: "group px-1 py-4", children: ({ isActive }) => {
                        const classes = classNames('text-center min-w-nav text-body-small font-semibold px-8 py-2.5 shadow transition-colors duration-500', 'focus:outline-green', isActive
                            ? variants[route.meta.variant]
                            : 'text-green-600 bg-grey-50');
                        return (_jsx("button", { className: classes, onClick: handleClick, children: route.meta.title }));
                    } }, route.path));
            }) }) }));
};
export default MobileNavigation;
